import interpolateStringToTemplate from '../../utils/interpolate-string-to-template';

const compileCustomSchemeTemplate = (customSchemeTemplate, schemeId, variables) =>
  interpolateStringToTemplate(customSchemeTemplate, { scheme_id: schemeId, ...variables });

export default compileCustomSchemeTemplate;
